import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ProjectRepository from '@/app/project/infrastructure/persistence/ProjectRepository';
import { ref, watch, inject } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputProjects',
  props: ['modelValue', 'filters'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

const repository = inject('projectRepository') as ProjectRepository;



const projectOptions = ref<any[]>([]);

watch(props, async(newProp) => {
    projectOptions.value = await repository.getAllSimple(newProp.filters);
}, { immediate: true});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    "model-value": __props.modelValue,
    label: "Projeto",
    "item-title": "name",
    "item-value": "id",
    items: projectOptions.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:modelValue', value))
  }, null, 8, ["model-value", "items"]))
}
}

})